import { ALL_BUILDING_TYPES, BuildingType } from '../types/BuildingTypeEnums';
import { translate } from '../types/EnumTranslations';

/**
 * The types to offer, in display order: those enabled on the instance plus
 * those in `alsoInclude` (types still used by a building, or a building's
 * current type), so nothing that exists becomes unselectable.
 */
export function offeredBuildingTypes(
    enabled: readonly BuildingType[] | null,
    alsoInclude: Iterable<string | undefined> = [],
): BuildingType[] {
    const wanted = new Set<string>(enabled ?? []);
    for (const type of Array.from(alsoInclude)) {
        if (type) wanted.add(type);
    }
    return ALL_BUILDING_TYPES.filter(type => wanted.has(type));
}

export interface BuildingTypeLabelOption {
    label: string;
    value: BuildingType;
}

export function buildingTypeLabelOptions(types: readonly BuildingType[]): BuildingTypeLabelOption[] {
    return types.map(type => ({ label: translate(type), value: type }));
}
